import GenericWizard from './GenericWizard.component';
import { WizardStep, WizardOptions, WizardNavigationProps, WizardHeaderProps } from './types';

export type { WizardStep, WizardOptions, WizardNavigationProps, WizardHeaderProps };
export default GenericWizard;